import React, { useEffect, useRef } from 'react';
import { STATUS_ACTIVE } from '@constants';
import useTranslate from '@hooks/useTranslate';
import { TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { calcCoefficient } from '@utils';
import { Col, Form, Row } from 'antd';

import BeilageForm from './BeilageForm';

const BeilageTemplateForm = ({
    formId,
    handleAddMoreBeilage,
    formRef,
    isEditing,
    dataDetail,
    onSubmit,
    form,
    actions,
    setIsChangedFormValues,
}) => {
    const translate = useTranslate();
    const internalFormRef = useRef();

    const getInitialFormValues = () => {
        if (!isEditing) {
            return { status: STATUS_ACTIVE, beilages: [] };
        }
        return { ...dataDetail };
    };

    const handleSubmit = (values) => {
        onSubmit(values);
    };

    useEffect(() => {
        if (isEditing && dataDetail) {
            const modifiedDataDetail = {
                ...dataDetail,
                beilages: dataDetail.beilages?.map(beilage => ({
                    ...beilage,
                    food_datas: beilage.food_datas?.map(food => ({
                        ...food,
                        price: calcCoefficient(food.price, 100),
                    })),
                })),
            };
            form.setFieldsValue(modifiedDataDetail);
        } else {
            form.resetFields();
            form.setFieldsValue({ status: STATUS_ACTIVE, beilages: [] });
        }
    }, [ isEditing, dataDetail, form ]);

    return (
        <Form
            id={formId}
            form={form}
            ref={(ref) => {
                internalFormRef.current = ref;
                formRef.current = ref;
            }}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={getInitialFormValues()}
            onValuesChange={() => setIsChangedFormValues(true)}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <TextField
                        name="name"
                        placeholder={translate.formatMessage(commonMessage.name)}
                        label={translate.formatMessage(commonMessage.name)}
                        requiredMsg={translate.formatMessage(commonMessage.name)}
                        required
                    />
                </Col>
            </Row>
            <BeilageForm form={form} handleAddMoreBeilage={handleAddMoreBeilage} formRef={formRef} />
            {/* {actions} */}
        </Form>
    );
};

export default BeilageTemplateForm;
